import Slider from "react-slick";
import { Leaf } from 'lucide-react';

import mapImg from "../../assets/images/map-evcharge.png";
import p1 from "../../assets/images/1.jpeg";
import p2 from "../../assets/images/2.jpeg";
import p3 from "../../assets/images/3.jpeg";
import p4 from "../../assets/images/4.jpeg";
import p5 from "../../assets/images/5.jpeg";
import p6 from "../../assets/images/6.jpeg";
import p7 from "../../assets/images/7.jpg";
import p8 from "../../assets/images/8.png";

const Mission = () => {
  const settings = {
    dots: false,
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,

    // KEY SETTINGS 👇
    autoplaySpeed: 2000, // pause time (2 seconds)
    speed: 800,          // slide animation speed
    cssEase: "ease-in-out",

    slidesToShow: 5,
    slidesToScroll: 1,
    pauseOnHover: true,
    swipeToSlide: true,

    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3 } },
      { breakpoint: 600, settings: { slidesToShow: 2 } }
    ]
  };
  const missionItems = [
    {
      id: 1,
      text: "Expert establishment of High Tension (HT) and Low Tension (LT) electrical networks."
    },
    {
      id: 2,
      text: "Commitment to zero-accident project sites through strict GEB and international safety codes."
    },
    {
      id: 3,
      text: "Bridging the gap between heavy machinery imports and sustainable energy infrastructure."
    }
  ];

  return (
    <section className="mission py-10">
      <div className="container">

        {/* Mission */}
        <div className="mission-inner border-dashed border-2 mb-7 pb-7 border-top-0 border-start-0 border-end-0">
          <div className="row align-items-center gy-5 gx-lg-5">
            <div className="col-lg-6">
              <img src={mapImg} className="w-100" alt="mission" />
            </div>
            <div className="col-lg-6">
              <h6 className="green1">Convenient & fast</h6>
              <h2 className="ps-4 border-start border-3 border-green">
                <span className="green">our mission</span> is to charge your EV properly
              </h2>
              <div className="section-body">
              {/* Introduction paragraph highlighting your industry role */}
              <p className="text-muted leading-relaxed mt-5">
                Denial Enterprise is dedicated to providing high-performance electrical infrastructure
                for multinational corporations. We specialize in complex substation building and
                turnkey EV charging deployments that guarantee 99.9% network uptime.
              </p>

              {/* Mission List with Lucide Icons and Bootstrap styling */}
              <ul className="list-unstyled mission-list fw-bold mt-4 pt-4 border-dashed border-2 border-bottom-0 border-start-0 border-end-0 border-lightgreen">
                {missionItems.map((item) => (
                  <li key={item.id} className="mb-3 d-flex align-items-start">
                    <Leaf
                      className="text-success me-2 mt-1 flex-shrink-0"
                      size={18}
                      fill="currentColor"
                    />
                    <span className="text-dark">{item.text}</span>
                  </li>
                ))}
              </ul>
            </div>
            </div>
            
          </div>
        </div>

        {/* Partners */}
        <div className="row align-items-center">
          <div className="col-lg-2">
            <h3 className="ps-4 border-start border-3 border-green">
              Our <span className="green">partners</span>
            </h3>
          </div>

          <div className="col-lg-10">
            <Slider {...settings} className="partner-slider">
              {[p1, p2, p3, p4, p5, p6, p7,p8].map((img, i) => (
                <div key={i} className="partner-slide">
                  <img src={img} alt="partner" />
                </div>
              ))}
            </Slider>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Mission;
